let API_BASE_URL = "";

const readEnv = () => {
  if (typeof import.meta !== "undefined" && import.meta?.env) {
    return import.meta.env;
  }

  if (typeof process !== "undefined" && process?.env) {
    return process.env;
  }

  return {};
};

const isBrowser = () => typeof window !== "undefined" && !!window?.location;

const resolveRelativeBase = (env, fallback) => {
  if (!isBrowser()) {
    return fallback;
  }

  if (typeof fallback !== "string" || !fallback.startsWith("/")) {
    return fallback;
  }

  const { protocol, hostname, port: currentPort } = window.location;
  const isDev = Boolean(env?.DEV ?? env?.MODE === "development");

  const preferredPort =
    env?.VITE_API_PORT ||
    env?.VITE_BACKEND_PORT ||
    env?.API_PORT ||
    (isDev && ["5173", "4173"].includes(currentPort) ? "5000" : undefined);

  const finalPort = preferredPort || currentPort || "";
  const host = finalPort ? `${hostname}:${finalPort}` : hostname;

  return `${protocol}//${host}${fallback}`;
};

export const resolveApiBase = (fallback = "/api") => {
  const env = readEnv();
  const explicit = env?.VITE_API_BASE || env?.VITE_API_URL;
  if (explicit) {
    return explicit;
  }

  return resolveRelativeBase(env, fallback);
};

export const setApiBase = (url) => {
  API_BASE_URL = url ?? resolveApiBase("");
  if (API_BASE_URL) {
    console.log(`[API] Base URL set to: ${API_BASE_URL}`);
  } else {
    console.warn("[API] Base URL cleared");
  }
};

export const getApiBase = () => API_BASE_URL || resolveApiBase("");
